<div class="screen">

  <!-- ── Hero ── -->
  <div class="hero-card" [attr.data-tension]="tensionKey()">
    <span class="hero-badge" [attr.data-tension]="tensionKey()">
      <span class="hero-badge-dot" [attr.data-tension]="tensionKey()"></span>
      {{ tensionLabel() }}
    </span>
    <div class="hero-top">
      <h1 class="hero-name">{{ site.nom }}</h1>
    </div>
  </div>

  <!-- ── Nom ── -->
  <p class="section-label">{{ 'mobileSimulator.canal.nameLabel' | translate }}</p>
  <input class="canal-input" type="text" [(ngModel)]="canalName" [placeholder]="'mobileSimulator.canal.namePlaceholder' | translate" />

  <!-- ── Membres ── -->
  <div class="section-row">
    <p class="section-label">
      {{ 'mobileSimulator.canal.membersLabel' | translate }}
      @if (selectedIds().length > 0) {
        <span class="members-count">{{ (selectedIds().length > 1 ? 'mobileSimulator.common.selectedPlural' : 'mobileSimulator.common.selectedSingular') | translate: { count: selectedIds().length } }}</span>
      }
    </p>
    <button class="filter-chip" [class.filter-chip--active]="hasActiveFilter" (click)="openFilter.emit()">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
        <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A1 1 0 0 0 18.95 4H5.04a1 1 0 0 0-.79 1.61z"/>
      </svg>
      {{ 'mobileSimulator.common.filtre' | translate }}
      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </button>
  </div>

  <div class="search-wrap">
    <svg class="search-icon" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
    </svg>
    <input class="search-input" type="text" [value]="search()" (input)="search.set($any($event.target).value)" [placeholder]="'mobileSimulator.canal.searchPlaceholder' | translate" />
    @if (search()) {
      <button class="search-clear" (click)="search.set('')">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    }
  </div>

  <div class="membres-list">
    @for (m of filteredMembres; track m.id) {
      <div class="membre-item" [class.membre-item--selected]="isSelected(m.id)">
        <div class="membre-info">
          <span class="membre-nom">{{ m.nom }}</span>
          <span class="membre-meta">{{ m.role }}</span>
        </div>
        <span class="dispo-chip" [attr.data-dispo]="m.dispo">{{ dispoLabel(m.dispo) }}</span>
        <button class="membre-add-btn" [class.membre-add-btn--added]="isSelected(m.id)" (click)="toggleMembre(m.id)">
          @if (isSelected(m.id)) {
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          } @else {
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
            </svg>
          }
        </button>
      </div>
    }
    @if (filteredMembres.length === 0) {
      <p class="membres-empty">{{ 'mobileSimulator.common.noResults' | translate }}</p>
    }
  </div>

  <button class="create-btn" [disabled]="!canalName.trim()" (click)="create()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
    {{ 'mobileSimulator.canal.createButton' | translate }}
  </button>

</div>